export default{
  month: 'Month',
  year: 'Year',
  totalPayout: 'Total Payout',
  show: 'Show',
  from: 'from',
  date: 'Date',
  status: 'Status',
  type: 'Type',
  transaction: 'Transaction',
  shippingCost: 'ShippingCost',
  dataNotAvailable: 'Data not available'
}